import TableSortHeader from 'components/table/TableSortHeader';
import { AccountStatusConstant, AccountTypeConstant } from 'constants/code.constant';
import useAccount from 'hooks/useAccount';
import useModal from 'hooks/useModal';
import useSortTable from 'hooks/useSortTable';
import { useState } from 'react';
import Pagination from 'react-js-pagination';

const headCells = [
  { label: '#', width: '5%' },
  { label: '소속명' },
  { label: '이름', width: '20%' },
  { label: '선택', width: '10%' },
];

const ProjectItemConsultantSelectModal = ({ consultantSelectCallback, selectedConsultantId }) => {
  const [company, setCompany] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const limit = 10;

  const { closeModal } = useModal();
  const { sortBy, sortOrder, handleRequestSort } = useSortTable();
  const { useGetAccountList } = useAccount();

  const {
    list: accountList,
    totalCount,
    refetch,
  } = useGetAccountList({
    page,
    limit,
    company,
    name,
    accountType: [AccountTypeConstant.CONSULTANT, AccountTypeConstant.ADMIN],
    status: AccountStatusConstant.ACTIVE,
  });

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    refetch();
  };

  const handlePageChange = (value) => {
    setPage(value);
  };

  return (
    <div className="project-item-consultant-select-modal">
      <p className="title">컨설턴트 선택</p>
      <form>
        <div className="table-search-wrap">
          <div>
            <label>소속명</label>
            <input type="text" placeholder="소속명" maxLength={100} onChange={(e) => setCompany(e.target.value)} />
          </div>
          <div>
            <label>이름</label>
            <input type="text" placeholder="이름" maxLength={100} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="btn text-left">
            <button className="btn" onClick={handleSearch}>
              검색
            </button>
          </div>
        </div>
      </form>
      <br />
      <div className="table-wrap">
        <p className="text-left">
          조회된 수: <strong>{totalCount}</strong>개
        </p>
        <table>
          <TableSortHeader
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleRequestSort={handleRequestSort}
            headCells={headCells}
          />
          <tbody>
            {totalCount === 0 && (
              <tr>
                <td colSpan={headCells.length}>검색 결과가 없습니다.</td>
              </tr>
            )}
            {accountList.map((item, index) => (
              <tr key={index}>
                <td>{totalCount - (page - 1) * limit - index}</td>
                <td>{item.company}</td>
                <td>{item.name}</td>
                <td>
                  {selectedConsultantId === item.accountId ? (
                    <button
                      className="btn error-btn"
                      onClick={() => {
                        consultantSelectCallback({});
                        closeModal();
                      }}
                    >
                      해제
                    </button>
                  ) : (
                    <button
                      className="btn add-btn"
                      onClick={() => {
                        consultantSelectCallback(item);
                        closeModal();
                      }}
                    >
                      선택
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {totalCount > 0 && (
          <Pagination
            activePage={page}
            itemsCountPerPage={limit}
            totalItemsCount={totalCount}
            pageRangeDisplayed={10}
            onChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectItemConsultantSelectModal;
